<template>
  <div class="">
    <div class="row justify-content-end">
      <div class="col-auto">
        <button @click="refresh()" class="btn btn-secondary">
          <i class="bi bi-arrow-clockwise"></i>
          Actualiser
        </button>
      </div>
      <div class="col-auto">
        <button @click="$router.push({ name: 'settings-create' })" class="btn btn-primary">
          <i class="bi bi-plus-square"></i>
          Créer une nouvelle parametre
        </button>
      </div>
    </div>
    <br />
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Référence</th>
          <th scope="col">Key</th>
          <th scope="col">Value Type</th>
          <th scope="col">Value</th>
          <th scope="col">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(setting, index) in settings" :key="setting.reference">
          <td>{{ index + 1 }}</td>
          <td>{{ setting.reference }}</td>
          <td>{{ setting.key }}</td>
          <td>{{ setting.valueType }}</td>
          <td>{{ setting.value }}</td>
          <td class="text-nowrap">
            <button @click="
              $router.push({
                name: 'settings-edit',
                params: {
                  reference: setting.reference,
                },
              })
              " class="btn btn-sm btn-outline-primary me-1">
              <i class="bi bi-pencil-square"></i>
            </button>
            <button v-if="$userRole == 'Admin'" @click="remove(setting)" class="btn btn-sm btn-outline-danger">
              <i class="bi bi-trash"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      search_value: "",
      addedToday: false,
      sortValue: "",
    };
  },
  computed: {
    ...mapGetters("setting", {
      settings: "getSettings",
    }),
  },
  mounted() {
    this.$store.dispatch("setting/getAll");
  },
  methods: {
    async refresh() {
      return await this.$store.dispatch("setting/getAll");
    },
    async remove(data) {
      let setting = data;
      await this.$confirm({
        message: "Vous voulez supprimer le paramètre " + setting.key,
        button: {
          no: "Non",
          yes: "Oui",
        },
        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("setting/destroy", setting.reference);
          }
        },
      });
    }
  },
};
</script>